const initialState = {
  currentTheme: "default", // Default theme
  themes: {
    default: {
      primary: "#2BB344",
      secondary: "rgba(43, 179, 68, 0.1)", // Dark Green
      // border: "#FDF9E0", // Green
      // icon: "#FDF9E0", // Blue
      // text: "#FDF9E0", // White
      // background: "#FDF9E0", // White
    },
    yellow: {
      primary: "#FFC218", // Bright Orange
      secondary: "rgba(255, 194, 24, 0.1)", // Dark Orange
      // border: "#FFC218", // Bright Orange
      // icon: "#FFC218", // Dark Orange
      // text: "#FFC218", // Bright Orange
    },
    red: {
      primary: "#E0011C", // Bright Red
      secondary: "rgba(224, 1, 28, 0.1)", // Dark Red
      // border: "#E0011C", // Bright Red
      // icon: "#E0011C", // Dark Red
      // text: "#E0011C", // Bright Red
    },
    blue: {
      primary: "#0BA2FF", // Bright Purple
      secondary: "rgba(11, 162, 255, 0.1)", // Dark Purple
      // border: "#0BA2FF", // Bright Purple
      // icon: "#0BA2FF", // Dark Purple
      // text: "#0BA2FF", // Bright Purple
    },
  },
  fonts: {
    default: "'Inter', sans-serif",
    underdog: "'Underdog', cursive",
    poppins: "'Poppins', sans-serif",
    ubuntu: "'Ubuntu', sans-serif",
    rubik: "'Rubik', sans-serif",
    outfit: "'Outfit', sans-serif",
    prompt: "'Prompt', sans-serif",
    lato: "'Lato', sans-serif",
  },
  currentFont: "default", // Default font
};

// Action Types
export const SET_THEME = "SET_THEME";
export const SET_FONT = "SET_FONT";

// Action Creators
export const setTheme = (theme) => ({
  type: SET_THEME,
  payload: theme,
});

export const setFont = (font) => ({
  type: SET_FONT,
  payload: font,
});

// Reducer
export default function themeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        currentTheme: action.payload,
      };
    case SET_FONT:
      return {
        ...state,
        currentFont: action.payload,
      };
    default:
      return state;
  }
}
